/* eslint-disable require-await */
/**
 * @typedef {module:emoji-picker.EmojiPicker} EmojiPicker
 */
import { html } from 'lit';
import { converse, api, _converse } from '@converse/headless';
import { CustomElement } from 'shared/components/element.js';
import { tplAllEmojis, tplSearchResults } from './templates/emoji-picker.js';
import { getTonedEmojis } from './utils.js';
import { FILTER_CONTAINS } from 'shared/autocomplete/utils.js';
const { sizzle, Strophe, $iq, u, stx } = converse.env;

export default class EmojiPickerContent extends CustomElement {
    static get properties() {
        return {
            'search_results': { type: Array },
            'current_skintone': { type: String },
            'model': { type: Object },
            'query': { type: String },
        };
    }

    constructor() {
        super();
        this.model = null;
        this.current_skintone = null;
        this.query = null;
        this.search_results = null;
    }

    render() {
        const props = {
            'current_skintone': this.current_skintone,
            'insertEmoji': /** @param {MouseEvent} ev */ (ev) => this.insertEmoji(ev),
            'query': this.query,
            'search_results': this.search_results,
            'shouldBeHidden': /** @param {string} shortname */ (shortname) => this.shouldBeHidden(shortname),
        };
        return html`<div class="emoji-picker__lists">${tplSearchResults(props)} ${tplAllEmojis(props)}</div>`;
    }

    firstUpdated() {
        this.initIntersectionObserver();
    }

    initIntersectionObserver() {
        if (!window.IntersectionObserver) {
            return;
        }
        if (this.observer) {
            this.observer.disconnect();
        } else {
            const options = {
                root: this.querySelector('.emoji-picker__lists'),
                threshold: [0.1],
            };
            const handler = (ev) => this.setCategoryOnVisibilityChange(ev);
            this.observer = new IntersectionObserver(handler, options);
        }
        sizzle('.emoji-picker', this).forEach((a) => this.observer.observe(a));
    }

    setCategoryOnVisibilityChange(entries) {
        const selected = /** @type {EmojiPicker} */ (this.parentElement).navigator.selected;
        const intersection_with_selected = entries.filter((i) => i.target.contains(selected)).pop();
        let current;
        // Choose the intersection that contains the currently selected
        // element, or otherwise the one with the largest ratio.
        if (intersection_with_selected) {
            current = intersection_with_selected;
        } else {
            current = entries.reduce((p, c) => (c.intersectionRatio >= (p?.intersectionRatio || 0) ? c : p), null);
        }
        if (current && current.isIntersecting) {
            const category = current.target.getAttribute('data-category');
            if (category !== this.model.get('current_category')) {
                /** @type {EmojiPicker} */ (this.parentElement).preserve_scroll = true;
                u.safeSave(this.model, { 'current_category': category });
            }
        }
    }

    /**
     * @param {MouseEvent} ev
     */
    // insertEmoji (ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();
    //     const target = /** @type {HTMLElement} */(ev.target);
    //     const emoji_el = target.nodeName === 'IMG' ? target.parentElement : target;
    //     /** @type EmojiPicker */(this.parentElement).selectEmoji(emoji_el.getAttribute('data-emoji'));
    // }
    //      insertEmoji (ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();
    //     const target = /** @type {HTMLElement} */(ev.target);
    //     const emoji_el = target.nodeName === 'IMG' ? target.parentElement : target;

    //     // Отримуємо shortname, наприклад ":crazy_face:"
    //     const shortname = emoji_el.getAttribute('data-emoji');

    //     // Конвертуємо його в реальний Unicode символ (🤪)
    //     const unicodeEmoji = u.shortnamesToUnicode(shortname);

    //     console.debug(`[Sonata UI] Emoji selected: ${unicodeEmoji}`);

    //     /** @type EmojiPicker */(this.parentElement).selectEmoji(unicodeEmoji);
    // }
    //working
    // insertEmoji(ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();

    //     const target = /** @type {HTMLElement} */ (ev.target);

    //     // Вместо ручного перебора parentElement используем closest.
    //     // Это найдет ближайший элемент с атрибутом data-emoji, даже если кликнули по <img> внутри него.
    //     const emoji_el = target.closest('[data-emoji]');

    //     if (!emoji_el) return;

    //     const shortname = emoji_el.getAttribute('data-emoji');

    //     // Безопасно конвертируем (теперь shortnamesToUnicode защищена внутри)
    //     const unicodeEmoji = u.shortnamesToUnicode(shortname);

    //     if (unicodeEmoji) {
    //         console.debug(`[Sonata UI] Emoji selected: ${unicodeEmoji}`);
    //         /** @type EmojiPicker */ (this.parentElement).selectEmoji(unicodeEmoji);
    //     }
    // }

    // async insertEmoji(ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();

    //     const target = /** @type {HTMLElement} */ (ev.target);
    //     const emoji_el = target.closest('[data-emoji]');
    //     if (!emoji_el) return;

    //     const shortname = emoji_el.getAttribute('data-emoji');
    //     const unicodeEmoji = u.shortnamesToUnicode(shortname);

    //     if (unicodeEmoji) {
    //         const purposeElement = this.closest('[purpose]');
    //         const purpose = purposeElement ? purposeElement.getAttribute('purpose') : null;

    //         if (purpose === 'reaction') {
    //             this.sendReactionStanza(unicodeEmoji);
    //         } else {
    //             // Кастуем родителя и результат closest к any, чтобы TS не ругался
    //             const picker = /** @type {any} */ (this.parentElement);
    //             const globalPicker = /** @type {any} */ (this.closest('converse-emoji-picker'));

    //             if (picker && typeof picker.selectEmoji === 'function') {
    //                 picker.selectEmoji(unicodeEmoji);
    //             } else if (globalPicker && typeof globalPicker.selectEmoji === 'function') {
    //                 globalPicker.selectEmoji(unicodeEmoji);
    //             }
    //         }
    //     }
    // }
    // async insertEmoji(ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();

    //     const target = /** @type {HTMLElement} */ (ev.target);
    //     const emoji_el = target.closest('[data-emoji]');
    //     if (!emoji_el) return;

    //     const shortname = emoji_el.getAttribute('data-emoji');

    //     // 1. Пытаемся получить юникод стандартным способом
    //     let unicodeEmoji = u.shortnamesToUnicode(shortname);

    //     // 2. ХАК ДЛЯ КАСТОМНЫХ ЭМОДЗИ (PNG -> Unicode)
    //     // Если конвертация вернула шортнейм (например, :saluting_face:),
    //     // проверяем наш список соответствий для iPhone
    //     if (unicodeEmoji === shortname || unicodeEmoji.includes(':')) {
    //         const customMapping = {
    //             ':saluting_face:': '1fae1',
    //             ':pink_heart:': '1fa77',
    //             // добавьте сюда другие, если нужно
    //         };

    //         const cp = customMapping[shortname];
    //         if (cp) {
    //             // Используем функцию из вашего хелпера для превращения hex в символ
    //             // Если u.convert доступен глобально, иначе используем String.fromCodePoint
    //             unicodeEmoji = String.fromCodePoint(parseInt(cp, 16));
    //         }
    //     }

    //     // 3. Если всё равно не юникод (например, это логотип :converse:),
    //     // то для реакций лучше вообще не слать такое, так как iPhone не поймет PNG.
    //     if (unicodeEmoji && !unicodeEmoji.includes(':')) {
    //         const purposeElement = this.closest('[purpose]');
    //         const purpose = purposeElement ? purposeElement.getAttribute('purpose') : null;

    //         if (purpose === 'reaction') {
    //             this.sendReactionStanza(unicodeEmoji);
    //         } else {
    //             // Обычная вставка в текстовое поле (тут шортнейм ок)
    //             const picker = /** @type {any} */ (this.parentElement);
    //             const globalPicker = /** @type {any} */ (this.closest('converse-emoji-picker'));

    //             if (picker?.selectEmoji) {
    //                 picker.selectEmoji(unicodeEmoji);
    //             } else if (globalPicker?.selectEmoji) {
    //                 globalPicker.selectEmoji(unicodeEmoji);
    //             }
    //         }
    //     } else {
    //         console.warn('[Sonata UI] Emoji has no unicode equivalent, ignoring for reaction:', shortname);
    //     }
    // }

    async insertEmoji(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const target = /** @type {HTMLElement} */ (ev.target);
        const emoji_el = target.closest('[data-emoji]');
        if (!emoji_el) return;

        const shortname = emoji_el.getAttribute('data-emoji');
        const purposeElement = this.closest('[purpose]');
        const purpose = purposeElement ? purposeElement.getAttribute('purpose') : null;

        const customMapping = {
            ':saluting_face:': '1fae1',
            ':pink_heart:': '1fa77',
        };

        // Сразу готовим Unicode-символ для обоих случаев
        let unicodeEmoji = u.shortnamesToUnicode(shortname);
        if (shortname in customMapping) {
            const cp = customMapping[shortname];
            unicodeEmoji = cp ? String.fromCodePoint(parseInt(cp, 16)) : null;
        }

        if (purpose === 'reaction') {
            // ДЛЯ РЕАКЦИЙ: Строго Unicode
            if (unicodeEmoji && !unicodeEmoji.includes(':')) {
                this.sendReactionStanza(unicodeEmoji);
            }
        } else {
            // ДЛЯ ТЕКСТОВОГО ПОЛЯ: Теперь тоже передаем корректный Юникод-символ!
            // Converse сам переварит его в PNG внутри текстовой области, если это настроено,
            // либо оставит красивым нативным смайлом (не текстом :flushed:)
            const picker = /** @type {any} */ (this.parentElement);
            const globalPicker = /** @type {any} */ (this.closest('converse-emoji-picker'));
            const targetPicker = picker?.selectEmoji ? picker : globalPicker;

            if (targetPicker && unicodeEmoji) {
                // Передаем юникод-символ (например, "😳"), а не шорткод ":flushed:"
                targetPicker.selectEmoji(unicodeEmoji);
            }
        }
    }

    // async insertEmoji(ev) {
    //     ev.preventDefault();
    //     ev.stopPropagation();

    //     const target = /** @type {HTMLElement} */ (ev.target);
    //     const emoji_el = target.closest('[data-emoji]');
    //     if (!emoji_el) return;

    //     const shortname = emoji_el.getAttribute('data-emoji');
    //     const purposeElement = this.closest('[purpose]');
    //     const purpose = purposeElement ? purposeElement.getAttribute('purpose') : null;

    //     const customMapping = {
    //         ':saluting_face:': '1fae1',
    //         ':pink_heart:': '1fa77',
    //     };

    //     if (purpose === 'reaction') {
    //         // ДЛЯ РЕАКЦИЙ: Строго Unicode (уже работает)
    //         let unicodeEmoji = u.shortnamesToUnicode(shortname);
    //         if (shortname in customMapping) {
    //             const cp = customMapping[shortname];
    //             unicodeEmoji = cp ? String.fromCodePoint(parseInt(cp, 16)) : null;
    //         }
    //         if (unicodeEmoji && !unicodeEmoji.includes(':')) {
    //             this.sendReactionStanza(unicodeEmoji);
    //         }
    //     } else {
    //         // ДЛЯ ТЕКСТОВОГО ПОЛЯ: Всегда вставляем shortname
    //         // Это гарантирует, что Converse покажет PNG-картинку, а не кракозябру
    //         const picker = /** @type {any} */ (this.parentElement);
    //         const globalPicker = /** @type {any} */ (this.closest('converse-emoji-picker'));
    //         const targetPicker = picker?.selectEmoji ? picker : globalPicker;

    //         if (targetPicker) {
    //             targetPicker.selectEmoji(shortname);
    //         }
    //     }
    // }
    /**
     * Формирование и отправка XML-станзы реакции (Sonata Custom Format)
     * @param {string} unicodeEmoji
     */
    sendReactionStanza(unicodeEmoji) {
        let messageModel = this.model;
        const isPickerModel = (m) => !m || m.has('current_category') || m.has('query');

        if (isPickerModel(messageModel)) {
            const host = /** @type {any} */ (
                this.closest('converse-emoji-dropdown') || this.closest('converse-reaction-panel')
            );
            messageModel = host?.model;
        }

        if (!messageModel || isPickerModel(messageModel)) {
            console.error('[Sonata UI] Message Model not found.');
            return;
        }

        const msgid = messageModel.get('origin_id') || messageModel.get('stanza_id') || messageModel.get('msgid');
        const chatbox = messageModel.collection?.chatbox || /** @type {any} */ (this.closest('converse-chat'))?.model;
        const to_jid = chatbox?.get('jid');
        const type = messageModel.get('type') === 'groupchat' ? 'groupchat' : 'chat';
        const nick = sessionStorage.getItem('s_fullname') || api.connection.get().jid.split('@')[0];

        if (!to_jid || !msgid) return;

        // ВАЖНО: Убираем корневое <body>, чтобы сообщение не падало в чат как текст.
        // Пуш-сервер Sonata должен брать текст из <customize><body> или из <x key="reaction">.
        const stanza = stx`
            <message xmlns="jabber:client" to="${to_jid}" type="${type}" id="${u.getUniqueId()}">
                <origin-id xmlns="urn:xmpp:sid:0" id="${u.getUniqueId()}"/>
                
                <reactions xmlns="urn:xmpp:reactions:0" id="${msgid}">
                    <reaction>${unicodeEmoji}</reaction>
                </reactions>

                <customize xmlns="p1:push:customize" nick="${nick}">
                    <body>${unicodeEmoji}</body>
                </customize>

                <x xmlns="p1:push:custom" key="aps.mutable-content" value="1"/>
                <x xmlns="p1:push:custom" key="aps.thread-id" value="${to_jid}"/>
                <x xmlns="p1:push:custom" key="reaction_to" value="${msgid}"/>
                <x xmlns="p1:push:custom" key="reaction" value="${unicodeEmoji}"/>
                
                <no-copy xmlns='urn:xmpp:hints'/>
                <no-store xmlns='urn:xmpp:hints'/>
                <store xmlns="urn:xmpp:hints"/>
            </message>`;

        api.send(stanza);

        // Optimistic UI
        const own_jid = _converse.bare_jid;
        let reactions = JSON.parse(JSON.stringify(messageModel.get('reactions') || {}));

        Object.keys(reactions).forEach((emoji) => {
            reactions[emoji] = (reactions[emoji] || []).filter((jid) => jid !== own_jid);
            if (reactions[emoji].length === 0) delete reactions[emoji];
        });

        if (!reactions[unicodeEmoji]) reactions[unicodeEmoji] = [];
        reactions[unicodeEmoji].push(own_jid);

        messageModel.set('reactions', reactions);
        messageModel.trigger('change:reactions');

        api.trigger('hideEmojiPicker');
        document.body.click();
    }
    // sendReactionStanza(unicodeEmoji) {
    //     // 1. Находим реальную модель сообщения
    //     let messageModel = this.model;

    //     // Функция-помощник для проверки: является ли модель "технической" (моделью пикера)
    //     const isPickerModel = (m) => !m || m.has('current_category') || m.has('query');

    //     if (isPickerModel(messageModel)) {
    //         // Если это модель пикера или поиска, берем модель сообщения из родительского дропдауна
    //         const dropdown = /** @type {any} */ (this.closest('converse-emoji-dropdown'));
    //         messageModel = dropdown?.model;
    //     }

    //     // Если всё еще не нашли (например, из-за глубокого вложения), пробуем найти через родителя сообщения
    //     if (isPickerModel(messageModel)) {
    //         const actionsView = /** @type {any} */ (this.closest('converse-message-actions'));
    //         messageModel = actionsView?.model;
    //     }

    //     // Финальная проверка: если msgid нет, значит мы не нашли сообщение
    //     if (!messageModel || isPickerModel(messageModel)) {
    //         console.error('[Sonata UI] Could not find Message Model. Even in search mode.');
    //         return;
    //     }

    //     // 2. Извлекаем ID
    //     const msgid = messageModel.get('origin_id') || messageModel.get('stanza_id') || messageModel.get('msgid');

    //     // 3. Извлекаем JID чата и настройки
    //     const chatbox = messageModel.collection?.chatbox || /** @type {any} */ (this.closest('converse-chat'))?.model;
    //     const to_jid = chatbox?.get('jid');

    //     const type = messageModel.get('type') === 'groupchat' ? 'groupchat' : 'chat';
    //     const nick = sessionStorage.getItem('s_fullname') || api.connection.get().jid.split('@')[0];

    //     // Валидация перед отправкой
    //     if (!to_jid || !msgid || msgid.includes('converse.emoji')) {
    //         console.error('[Sonata UI] Data error:', { to_jid, msgid, attrs: messageModel.attributes });
    //         return;
    //     }

    //     // 4. Формируем станзу
    //     const stanza = stx`
    //         <message xmlns="jabber:client"
    //                  to="${to_jid}"
    //                  type="${type}"
    //                  id="${u.getUniqueId()}">

    //             <origin-id xmlns="urn:xmpp:sid:0" id="${u.getUniqueId()}"/>

    //             <reactions xmlns="urn:xmpp:reactions:0" id="${msgid}">
    //                 <reaction>${unicodeEmoji}</reaction>
    //             </reactions>

    //             <customize xmlns="p1:push:customize" nick="${nick}">
    //                 <body>${unicodeEmoji}</body>
    //             </customize>

    //             <x xmlns="p1:push:custom" key="aps.mutable-content" value="1"/>
    //             <x xmlns="p1:push:custom" key="aps.thread-id" value="${to_jid}"/>
    //             <x xmlns="p1:push:custom" key="reaction_to" value="${msgid}"/>
    //             <x xmlns="p1:push:custom" key="reaction" value="${unicodeEmoji}"/>
    //             <store xmlns="urn:xmpp:hints"/>
    //         </message>`;

    //     console.debug(`[Sonata UI] Success! Reacting to: ${msgid}`);
    //     api.send(stanza);

    //     // 5. Локальное обновление (Optimistic UI) с логикой ЗАМЕНЫ
    //     const own_jid = _converse.bare_jid;
    //     let reactions = messageModel.get('reactions') || {};

    //     // Клонируем объект, чтобы Backbone/Lit увидели изменения
    //     reactions = JSON.parse(JSON.stringify(reactions));

    //     // Удаляем старую реакцию текущего пользователя (если она была)
    //     Object.keys(reactions).forEach((emoji) => {
    //         reactions[emoji] = reactions[emoji].filter((jid) => jid !== own_jid);
    //         if (reactions[emoji].length === 0) {
    //             delete reactions[emoji];
    //         }
    //     });

    //     // Добавляем новую реакцию
    //     if (!reactions[unicodeEmoji]) {
    //         reactions[unicodeEmoji] = [];
    //     }
    //     reactions[unicodeEmoji].push(own_jid);

    //     // Сохраняем в модель и триггерим обновление интерфейса
    //     messageModel.set('reactions', reactions);
    //     messageModel.trigger('change:reactions');

    //     // Закрываем пикер
    //     api.trigger('hideEmojiPicker');
    //     document.body.click();
    // }
    // sendReactionStanza(unicodeEmoji) {
    //     // 1. Находим реальную модель сообщения
    //     // Если в this.model лежат категории, значит это модель пикера.
    //     // Пробуем взять модель из параметров выпадающего меню.
    //     let messageModel = this.model;

    //     if (messageModel && messageModel.has('current_category')) {
    //         // Если это модель пикера, ищем модель сообщения в родительских элементах
    //         const dropdown = /** @type {any} */ (this.closest('converse-emoji-dropdown'));
    //         messageModel = dropdown?.model || messageModel;
    //     }

    //     if (!messageModel || messageModel.has('current_category')) {
    //         console.error('[Sonata UI] Could not find Message Model. Current model is Picker Model.');
    //         return;
    //     }

    //     // 2. Извлекаем ID (теперь из правильной модели)
    //     const msgid = messageModel.get('origin_id') || messageModel.get('stanza_id') || messageModel.get('msgid');

    //     // 3. Извлекаем JID чата
    //     const chatbox = messageModel.collection?.chatbox || /** @type {any} */ (this.closest('converse-chat'))?.model;
    //     const to_jid = chatbox?.get('jid');

    //     const type = messageModel.get('type') === 'groupchat' ? 'groupchat' : 'chat';
    //     const nick = sessionStorage.getItem('s_fullname') || api.connection.get().jid.split('@')[0];

    //     if (!to_jid || !msgid || msgid.includes('converse.emoji')) {
    //         console.error('[Sonata UI] Data error:', { to_jid, msgid, attrs: messageModel.attributes });
    //         return;
    //     }

    //     const stanza = stx`
    //         <message xmlns="jabber:client"
    //                  to="${to_jid}"
    //                  type="${type}"
    //                  id="${u.getUniqueId()}">

    //             <origin-id xmlns="urn:xmpp:sid:0" id="${u.getUniqueId()}"/>

    //             <reactions xmlns="urn:xmpp:reactions:0" id="${msgid}">
    //                 <reaction>${unicodeEmoji}</reaction>
    //             </reactions>

    //             <customize xmlns="p1:push:customize" nick="${nick}">
    //                 <body>${unicodeEmoji}</body>
    //             </customize>

    //             <x xmlns="p1:push:custom" key="aps.mutable-content" value="1"/>
    //             <x xmlns="p1:push:custom" key="aps.thread-id" value="${to_jid}"/>
    //             <x xmlns="p1:push:custom" key="reaction_to" value="${msgid}"/>
    //             <x xmlns="p1:push:custom" key="reaction" value="${unicodeEmoji}"/>
    //             <store xmlns="urn:xmpp:hints"/>
    //         </message>`;

    //     console.debug(`[Sonata UI] Success! Reacting to: ${msgid}`);
    //     api.send(stanza);
    //     const own_jid = _converse.bare_jid;
    //     let reactions = messageModel.get('reactions') || {};

    //     // Глубокое клонирование для корректного срабатывания триггеров Lit/Backbone
    //     reactions = JSON.parse(JSON.stringify(reactions));

    //     // ЛОГИКА ЗАМЕНЫ: Удаляем наш JID из всех других эмодзи этого сообщения
    //     Object.keys(reactions).forEach((emoji) => {
    //         reactions[emoji] = reactions[emoji].filter((jid) => jid !== own_jid);
    //         // Если после удаления JID список пуст — удаляем сам ключ эмодзи
    //         if (reactions[emoji].length === 0) {
    //             delete reactions[emoji];
    //         }
    //     });

    //     // Добавляем новую реакцию
    //     if (!reactions[unicodeEmoji]) {
    //         reactions[unicodeEmoji] = [];
    //     }
    //     reactions[unicodeEmoji].push(own_jid);

    //     // Сохраняем и форсируем обновление
    //     messageModel.set('reactions', reactions);
    //     messageModel.trigger('change:reactions');

    //     api.trigger('hideEmojiPicker');
    //     document.body.click();

    //     // api.trigger('hideEmojiPicker');
    //     // document.body.click();
    // }

    /**
     * @param {string} shortname
     */
    shouldBeHidden(shortname) {
        // Helper method for the template which decides whether an
        // emoji should be hidden, based on which skin tone is
        // currently being applied.
        if (shortname.includes('_tone')) {
            if (!this.current_skintone || !shortname.includes(this.current_skintone)) {
                return true;
            }
        } else {
            if (this.current_skintone && getTonedEmojis().includes(shortname)) {
                return true;
            }
        }
        if (this.query && !FILTER_CONTAINS(shortname, this.query)) {
            return true;
        }
        return false;
    }
}

api.elements.define('converse-emoji-picker-content', EmojiPickerContent);
